import React, { useCallback, useEffect } from 'react';
import en from '../../lang/en-us';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Radio,
    RadioGroup,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
const { dashboard } = en;

function RadioButton({
    label = '',
    value = '',
    radioImg = '',
    cssClass = '',
    disabled = false,
    isError = false,
    errorMessage = '',
}) {
    return (
        <>
            <FormControlLabel
                value={value}
                control={<Radio />}
                disabled={disabled}
                label={
                    <>
                        {radioImg && <img src={`/images/${radioImg}`} alt="icon" />}
                        {label}
                        {isError && (
                            <FormHelperText
                                style={{ color: 'red', fontSize: 12 }}
                            >{`(* ${errorMessage})`}</FormHelperText>
                        )}
                    </>
                }
                className={cssClass}
            />
        </>
    );
}

export const useRadio = ({ initValue }: any) => {
    const [value, setValue] = React.useState(initValue);
    const reset = useCallback(() => {
        setValue(initValue);
    }, [initValue]);

    return {
        value,
        setValue,
        reset,
    };
};
export function CustomRadio({
    list = [] as any,
    title = '',
    name = '',
    extraClass = '',
    formGroupClass = '',
    selectedValue = 'Female',
    helperText = '',
    error = false,
    handleRadioChange = (value: any) => { },
    component: Component = RadioButton,
    isLoading = false,
}: any) {
    const { value, setValue } = useRadio({ initValue: selectedValue });
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleRadioChange((event.target as HTMLInputElement).value);
        setValue((event.target as HTMLInputElement).value);
    };
    useEffect(() => {
        setValue(selectedValue);
    }, [selectedValue]);
    return isLoading ? (
        <>
            <Skeleton width={'70%'} height={50} />
            <div
                style={{
                    display: 'flex',
                    width: '70%',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        width: '50%',
                    }}
                >
                    <Skeleton variant="circle" width={20} />
                    <Skeleton variant="text" width={'50%'} />
                </div>
                <div
                    style={{
                        display: 'flex',
                        width: '50%',
                    }}
                >
                    <Skeleton variant="circle" width={20} />
                    <Skeleton variant="text" width={'50%'} />
                </div>
            </div>
        </>
    ) : (
        <FormControl component="fieldset" className={`db-radio ${extraClass}`} error={error}>
            <FormLabel component="legend">{title}</FormLabel>
            <RadioGroup name={name} value={value} onChange={handleChange} className={formGroupClass}>
                {list.map((_childProps: any, index: any) => (
                    <Component key={index} {..._childProps} />
                ))}
            </RadioGroup>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
}
